import http from '@/utils/http';

export default {
  async getById(id) {
    return await http.get(`/api/denuncia/get/${id}`);
  },
  async insert(data) {
    return await http.post('/api/denuncia/insert', data);
  },
  async update(data) {
    return await http.post('/api/denuncia/update', data);
  },
  async delete(data) {
    return await http.post('/api/denuncia/delete', data);
  }
};